import reducer from "./reducers";

import * as eventAction from "./actions";

export { eventAction };

export default reducer;
